<script setup lang="ts">
type Props = {
  email: string
  text?: string
}

const props = defineProps<Props>();
</script>

<template>
  <a
    class="base-email"
    :href="`mailto:${props.email}`"
    target="_self"
  >
    {{ text ?? email }}
  </a>
</template>
<style lang="scss">
.base-email {
    color: inherit;
    text-decoration: none;
}
</style>
